export default {
  root: {
    backgroundColor: "transparent",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  select: {
    minHeight: "16px",
    padding: "10px 10px 9px",
    backgroundColor: "transparent",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
};